"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PotikiBrandContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _pinscomThemeContext = require("../../pinscomThemeContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable max-len */
var PotikiBrandContext = exports.PotikiBrandContext = _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext), {}, {
  brand: _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext.brand), {}, {
    key: 'potiki',
    partner: 'PINSCOM',
    broker: 'POTIKI',
    styleSheet: 'potiki',
    logos: [{
      key: 'potikyLogoNew',
      imageUrl: 'https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/Potiki_logo.jpg',
      redirectUrl: 'https://potiki.com.au/?_gl=1*1pf7cyx*_ga*MjkzMzQwODE5LjE3MDE3NTU1ODc.*_ga_GNV05PVDES*MTcwMzE5OTk4Ny4xLjAuMTcwMzE5OTk4Ny42MC4wLjA.'
    }, {
      key: 'petInsuranceGreyLogo',
      imageUrl: 'https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/pinscom_logo.png',
      redirectUrl: 'https://petinsurance.com.au'
    }],
    supportPhoneNumber: '1800 973 427',
    supportEmailAddress: 'potiki@petsure.com.au',
    favIconUrl: 'https://petsure.com.au/wp-content/uploads/2020/01/cropped-favicon-32x32.png'
  }),
  layout: _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext.layout), {}, {
    header: _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext.layout.header), {}, {
      contactDetails: /*#__PURE__*/_react["default"].createElement("aside", {
        className: "contactDetails"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/icons/icon_phone.png",
        className: "phoneIcon",
        alt: "phone icon for contact"
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel://1800973427"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Need help?"), /*#__PURE__*/_react["default"].createElement("span", null, "1800 973 427")))),
      pageTitleText: /*#__PURE__*/_react["default"].createElement("div", {
        className: "pageTitleText"
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Get a pet insurance quote"), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("small", null, "Powered by PetSure \u2013 Australia\u2019s leading Pet Insurance provider")))
    }),
    main: {
      heading: _objectSpread(_objectSpread({}, _pinscomThemeContext.pinscomThemeContext.layout.main.heading), {}, {
        showMandatoryText: true
      })
    },
    aside: {
      campaigns: [/*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "PotikiCampaign1",
        customCssClass: "PotikiCampaign1",
        campaignImageDescription: "Get a Pet insurance quote - Promo box a title",
        campaignImageUrl: "https://newquote.petinsurance.com.au/assets/images/promo_box_a_tile.jpg"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "PotikiCampaign2",
        customCssClass: "PotikiCampaign2",
        campaignImageDescription: "VetChat - Vet care in your pocket",
        campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Common/VetChat%20tile%20small.png"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "PotikiCampaign3",
        customCssClass: "PotikiCampaign3",
        campaignImageDescription: "GapOnly ready Pet Insurance",
        campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Common/GapOnly%20tile%20small%20232x200.png"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "PotikiCampaign4",
        customCssClass: "PotikiCampaign4",
        campaignImageDescription: "Get a Pet insurance quote - Pet prescription logo images",
        campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/modernization/pinscom/Petscripts_tile.png"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        key: "PotikiContactCampaign",
        className: "contactCard"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "callUsText"
      }, /*#__PURE__*/_react["default"].createElement("span", null, " Call us on", /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel:1800973427"
      }, "1800 973 427")), /*#__PURE__*/_react["default"].createElement("img", {
        src: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/icons/icon_footer_cat.svg",
        alt: "Monday to Friday (except public holidays) 08:00am to 08:00pm"
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "disclaimerText"
      }, "Monday to Friday (except public holidays) 08:00am to 08:00pm"))]
    },
    footer: {
      socialLinks: [],
      footerSections: [{
        content: /*#__PURE__*/_react["default"].createElement("div", {
          className: "topFooterText"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "leftFrame"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          target: "_blank",
          rel: "noreferrer",
          href: "https://potiki.com.au/"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          height: "100%",
          src: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/Potiki_inverted_logo.png",
          alt: "Get a Pet insurance quote - Pet Insurance footer logo",
          width: "210"
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "centerFrame"
        }, /*#__PURE__*/_react["default"].createElement("span", null, " Contact us on\xA0", /*#__PURE__*/_react["default"].createElement("a", {
          target: "_blank",
          rel: "noreferrer",
          href: "mailto@info@potiki.com.au"
        }, "info@potiki.com.au")), /*#__PURE__*/_react["default"].createElement("span", null, " Monday to Friday (except public holidays) "), /*#__PURE__*/_react["default"].createElement("span", null, " 8:00am to 8:00pm ")), /*#__PURE__*/_react["default"].createElement("div", {
          className: "rightFrame"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/pinscom/icons/icon_lock_white.svg",
          alt: "Get a Pet insurance quote - Lock icon",
          width: "24"
        }), /*#__PURE__*/_react["default"].createElement("span", null, "Secured by", /*#__PURE__*/_react["default"].createElement("br", null), "256-bit SSL")))
      }, {
        content: /*#__PURE__*/_react["default"].createElement("div", {
          className: "bottomFooterText"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "leftFrame"
        }, /*#__PURE__*/_react["default"].createElement("p", null, "\xA9 Copyright 2021 by www.petinsurance.com.au. All rights reserved.")), /*#__PURE__*/_react["default"].createElement("div", {
          className: "centerFrame"
        }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("a", {
          href: "https://potiki.com.au/assets/pdf/privacy%20-policy.pdf",
          target: "_blank",
          rel: "noreferrer"
        }, "Privacy Policy"), "\xA0", /*#__PURE__*/_react["default"].createElement("span", null, "| View the\xA0", /*#__PURE__*/_react["default"].createElement("a", {
          href: "https://potiki.com.au/",
          target: "_blank",
          rel: "noreferrer"
        }, "PDS"), "\xA0and\xA0", /*#__PURE__*/_react["default"].createElement("a", {
          href: "https://petinsurance.com.au/tmds/?__hstc=181257784.209ccb269612768db36ea6b42efe074a.1699849868311.1710814716298.1710816659049.72&__hssc=181257784.1.1710816659049&__hsfp=1214080036",
          target: "_blank",
          rel: "noreferrer"
        }, "TMD")))))
      }],
      customDisclosure: {
        brand: {
          link: 'https://www.petinsurance.com.au',
          label: 'Petinsurance.com.au'
        },
        tmd: {
          label: 'petinsurance.com.au'
        },
        authorisedRepresentative: 'PetSure’s Authorised Representatives (AR) Pet Insurance Pty Ltd ABN 38 607 160 930, AR 1234944 (PIPL) and Potiki Insurance Pty Ltd ABN 76 652 040 312, AR 1295320',
        footerDisclaimer: function footerDisclaimer(props) {
          return /*#__PURE__*/_react["default"].createElement("p", null, "This policy is issued by PetSure (Australia) Pty Ltd ABN 95 075 949 923, AFSL 420183 (PetSure) and promoted and distributed by PetSure\u2019s Authorised Representatives (AR) Pet Insurance Pty Ltd ABN 38 607 160 930, AR 1234944 (PIPL) and Potiki Insurance Pty Ltd ABN 76 652 040 312, AR 1295320. Any advice provided is general only and does not take into account your individual objectives, financial situation or needs. Please consider the Product Disclosure Statement (PDS) to ensure this product meets your needs before purchasing. PDS and Target Market Determination available at ", /*#__PURE__*/_react["default"].createElement("a", {
            target: "_blank",
            rel: "noreferrer",
            href: props.tmd.link,
            ref: props.disclaimerLink
          }, props.tmd.label), ".");
        },
        expireDate: '2024-03-31',
        discount: 50,
        hasGapOnly: true,
        hasPetScripts: true
      }
    }
  })
});